<template>
	<div class="fixed left bottom-0 w-screen flex px-4 justify-around items-center bg-white dark:bg-bs-gray-dark menu-bar z-50">
		
		<router-link active-class="menu-item-active"
			class="p-4" 
			to="/"
			v-slot="{isActive }"
		>
			<img :src="isActive ? menuIcons.home.active : menuIcons.home.outline" class="mx-4"  />
		</router-link>
		<router-link active-class="menu-item-active-mob"
		class="p-4"
		to="/settings"
		v-slot="{isActive }"
		>
			<img :src="isActive ? menuIcons.settings.active : menuIcons.settings.outline" class="mx-4"  />
		</router-link>
		<router-link active-class="menu-item-active-mob"
		class="p-4"
		to="/openclaw"
		v-slot="{isActive }"
		>
			<img :src="isActive ? menuIcons.openclaw.active : menuIcons.openclaw.outline" class="mx-4"  />
		</router-link>
		<!-- <div class="flex-grow" />-->
		<a @click.prevent="onLogout" class="text-white hover:bg-white hover:bg-opacity-20 rounded-xl cursor-pointer px-5 py-3">
			<img src="/img/menu/logout.outline.svg" class="mx-4"  />
		</a>
	</div>
</template>

<script>
import firebase from '@/firebase'
import {menuIcons} from "@/commons/helpers"
export default {
	data: function () {
		return {
			collapsed: window.innerWidth < 768,
			menuIcons
		}
	},
	methods: {
		onToggle: function () {
			this.collapsed = !this.collapsed
		},
		onLogout: function() {
			firebase.auth().signOut();
			this.$router.replace({ name: "Login" });
		},
	}

}
</script>

<style>
.menu-item-active-mob {
	@apply bg-white font-medium text-bs-dark-bg dark:bg-bs-dark-bg-over border-l border-r border-white dark:border-bs-blue-dark	dark:text-white;
}
.menu-bar {
	box-shadow: 0px -11px 50px rgba(0, 0, 0, 0.15);
}
</style>